import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { useSelector } from "react-redux";
//import logo
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

//Import Components
import VerticalLayout from "./VerticalLayouts";
import TwoColumnLayout from "./TwoColumnLayout";
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";
import SidebarUserProfile from "../Components/Common/SidebarUserProfile";
import "../assets/scss/components/SidebarUserProfile.scss";

const Sidebar = ({ layoutType } : any) => {

  // Logo thương hiệu (đồng bộ với trang Brand Management, giống Header.tsx)
  const brandingLogoUrl = useSelector((state: any) => state.BrandingConfiguration.config?.logoUrl);
  // Logo tuỳ chỉnh (upload) không có tỉ lệ cố định như ảnh mặc định của template,
  // nên cần kích thước rộng rãi hơn (22px/17px) để không bị hiển thị quá bé.
  const brandLogoSmStyle: React.CSSProperties = { height: 34, maxWidth: 34, width: 'auto', objectFit: 'contain' };
  const brandLogoLgStyle: React.CSSProperties = { height: 42, maxWidth: 160, width: 'auto', objectFit: 'contain' };

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={brandingLogoUrl || logoSm} alt="" height="22" style={brandingLogoUrl ? brandLogoSmStyle : undefined} />
            </span>
            <span className="logo-lg">
              <img src={brandingLogoUrl || logoDark} alt="" height="17" style={brandingLogoUrl ? brandLogoLgStyle : undefined} />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={brandingLogoUrl || logoSm} alt="" height="22" style={brandingLogoUrl ? brandLogoSmStyle : undefined} />
            </span>
            <span className="logo-lg">
              <img src={brandingLogoUrl || logoLight} alt="" height="17" style={brandingLogoUrl ? brandLogoLgStyle : undefined} />
            </span>
          </Link>
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>
        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === 'twocolumn' ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
            <div className="sidebar-background"></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
            <SidebarUserProfile />
            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
